import {
  ShieldAlert,
  Building2,
  ScrollText,
  AlertOctagon,
  Ban,
  CreditCard,
  Container,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ComponentProps } from 'react';
import { NavMain, type NavItem } from '@/components/nav-main';
import { NavUser } from '@/components/nav-user';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '@/components/ui/sidebar';

const navItems: NavItem[] = [
  { title: 'Organizations', url: '/orgs', icon: Building2 },
  { title: 'Billing', url: '/billing', icon: CreditCard },
  { title: 'Audit log', url: '/audit', icon: ScrollText },
  { title: 'Dead-letter queue', url: '/dlq', icon: AlertOctagon },
  { title: 'Sandboxes', url: '/sandboxes', icon: Container },
  { title: 'Force-cancel run', url: '/force-cancel', icon: Ban },
];

export function AppSidebar(props: ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link to="/orgs">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-destructive text-destructive-foreground">
                  <ShieldAlert className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">Flowlib</span>
                  <span className="truncate text-xs text-muted-foreground">Backoffice admin</span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navItems} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
